import { Component, OnInit, ViewChild } from '@angular/core';
import { BulletinType } from './bulletin-type';
import { BulletinTypeService } from './bulletin-type.service';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { Status } from '../status/status';
import { StatusService } from '../status/status.service';

@Component({
    templateUrl: './bulletin-type.component.html'
})

export class BulletinTypeComponent implements OnInit {

    @ViewChild('myTable') myTable;

    items: BulletinType[] = [];
    item: BulletinType = { id: null, code: null, description: null, status: null };
    outItem: BulletinType;
    selectedItem: BulletinType;
    msgs: Message[] = [];
    statuslist: Status[] = [];

    constructor(
        private activatedRoute: ActivatedRoute,
        private service: BulletinTypeService,
        private statusService: StatusService,
        ) { }

    ngOnInit() {
        this.statusService.findAll().subscribe(status => {
            this.statuslist = status.filter(x => x.type == "Master");
        });

        this.activatedRoute.params.subscribe(params => {
            this.items = this.activatedRoute.snapshot.data['items'];
        });
    }

    newItem() {
        this.msgs = [];
        this.selectedItem = { id: null, code: null, description: null, status: null };
        this.items = [this.selectedItem].concat(this.items);
        this.myTable.first = 0;
    }

    delete(item: BulletinType) {
        this.msgs = [];
        if (item.id != null){
           this.service.delete(item).subscribe( (data) => {
            const deletedItem = this.items.find(x => x.id === item.id);
            this.items.splice(this.items.indexOf(deletedItem), 1);

            this.msgs.push({
                severity: 'success',
                detail: 'Registro excluído'
            });
           }, (err) => {
            this.msgs.push({
                severity: 'error',
                detail: 'Não é possível excluir o registro'
            });
           });
        }
    }

    save(item: BulletinType) {
        this.msgs = [];
        if (item.code == null) this.msgs.push({severity:'error', detail:'Código obrigatório'});
        if (item.description == null) this.msgs.push({severity:'error', detail:'Descrição obrigatória'});
        if (item.status == null) this.msgs.push({severity:'error', detail:'Status obrigatório'});

        let msg = this.checkExist(item);
        if(msg) {
            this.msgs.push({
                severity: 'error',
                detail: msg
            });
        }


        if (this.msgs.length > 0)
            return;

        if (item.id == null){
            this.service.save(item).subscribe( params => {
                item.id = params.id;
                
                this.msgs.push({
                    severity: 'success',
                    detail: 'Registro incluído'
                });
            });
        } else {
            this.service.update(item).subscribe((data) => {
                this.msgs.push({
                    severity: 'success',
                    detail: 'Registro modificado'
                });
            });
        }
        this.selectedItem = null;
    }

    checkExist(item: BulletinType){
        if (item.id == null){
            for(let i = 0; i < this.items.length; i++) {
                if(this.items[i].id 
                    && this.items[i].code.trim().toUpperCase() == item.code.trim().toUpperCase()) {
                    return 'Não foi possível efetuar o cadastro. Registro já existe';
                }
            }
        } else {
            let quantity = 0;
            for(let i = 0; i < this.items.length; i++) {
                if( this.items[i].code.trim().toUpperCase() == item.code.trim().toUpperCase()) {
                    quantity++;
                    if(quantity > 1 ) {
                        return 'Não foi possível efetuar o cadastro. Registro já existe';
                    }
                } 
            }
        }
    }

    cancel(item : BulletinType) {
        this.msgs = [];
        if (this.selectedItem.id == null) {
            this.items.shift();
        }

        if(this.outItem != null && this.outItem.id != null){
            item.code = this.outItem.code;
            item.description = this.outItem.description;
            item.status = this.outItem.status;
        }

        this.selectedItem = null;
        this.outItem = null;
    }

    edit(item: BulletinType) {
        this.msgs = [];
        this.selectedItem = item;
        this.outItem = this.clone(item);
    }

    clone(i: BulletinType): BulletinType{
        let item = {id: null, code: null, description: null, status:null};
        for(let prop in i){
            item[prop] = i[prop];
        }
        return item;
    }

}